import { getApiErrorMessage } from '../services/apiClient'

const LEGACY_NO_LOTS = /no inventory lots exist at location/i

export function parseShipmentError(err) {
  const msg = getApiErrorMessage(err, '')
  if (LEGACY_NO_LOTS.test(msg)) {
    return 'No products are available for shipment in the selected warehouse. Choose another distribution center.'
  }
  if (msg) return msg
  return 'Failed to create shipment'
}
